module.exports = __webpack_public_path__ + "img/f3de683cbb4230c62a58764d687c9722.gif";